import { getBookingPrecision } from '@clubmed/domains-service';
export const getUserSearchesQuery = (locale: string) => ` query {
  userSearches {
    adults
    arrivalCity
    children
    birthdates
    departureCity
    departureDate
    isBookable
    reference
    resort  {
      badgeIcon
      comfort
      destination {
        country
      }
      href
      id
      images
      hasECSpace
      isCruise
      isExclusiveCollection
      isExplicitEC
      isJoyview
      isSummer
      isTour
      name
    }
    returnDate
    transportType
    price {
      formattedValue(precision: ${getBookingPrecision(locale)})
      value
    }
    type
    upsells(types: [TRANSFER]) {
      transfers {
        pricingInfo {
          id
          isFullyPaid
          isFullyRented
          isIncluded
          isPartiallyPaid
          isPartiallyRented
        }
      }
    }
  }
}`;
export const getProposalPriceQuery = (appContext: AppContext, proposalId: string) => ` query {
  proposal(id: "${proposalId}") {
    price {
      promoCode {
        offerColor
        offerId
        offerName
        amount {
          value
          formattedValue
        }
      }
    }
    households(withSchedule: true) {
      paymentSchedule {
        total {
          formattedValue(precision: ${getBookingPrecision(appContext.locale)})
          value
        }
      }
    }
  }
}`;
export const getProposalTotalPriceQuery = (appContext: AppContext, proposalId: string) => `query {
  proposal(id: "${proposalId}") {
    price {
      total {
        formattedValue(precision: ${getBookingPrecision(appContext.locale)})
        value
      }
      totalWithoutDiscount {
        formattedValue(precision: ${getBookingPrecision(appContext.locale)})
        value
      }
    }
  }
}`;
export const getProposalAccommodationsQuery = (proposalId: string) => `query {
  proposal(id: "${proposalId}") {
    accommodations {
      bathroomEquipments {
        id
        label
      }
      category
      categoryId
      comfortId
      comfortType
      description
      endDate
      equipments {
        id
        label
      }
      exclusiveCollection
      guest
      id
      label
      maxCapacity
      media {
        photos {
          url
        }
      }
      outsideFacilities {
        id
        label
      }
      quantity
      ranking
      rooms {
        number
      }
      roomType
      services {
        id
        label
      }
      startDate
      strengths {
        id
        label
      }
      surface
      view {
        id
        label
      }
      floorPlans
    }
  }
}`;
export const getSearchStreetViews = (
  productId: string,
  accommodationCategoryIds: Array<string>,
) => `query {
  streetViews(productId: "${productId}", accommodationCategoryIds:[${accommodationCategoryIds.map((id) => `"${id}"`).join(',')}]) {
    streetView {
      latitude
      longitude
      heading
      pitch
      fov
      url
    }
  }
}`;
export const getProposalTransportsQuery = (proposalId: string) => `query {
  proposal(id: "${proposalId}") {
    transports {
      multiTransport
      outbound {
        transferIncluded
        stayId
        durationInMin
        travelers {
          id
          name
          firstName
        }
        cancellationPolicyType
        travelSections {
          transport {
            baggage {
              quantity
              weight
              unit
            }
            class
            companyExploiter {
              id
              label
              logo
            }
            companyOperator {
              id
              label
              logo
              url
            }
            travelNumber
            type
            vehicleType
            carbonEmission
            averageCarbonEmission
          }
          departure {
            airportLabel
            cityId
            date
            id
            label
            terminalCode
            time
          }
          arrival {
            airportLabel
            cityId
            date
            id
            label
            terminalCode
            time
          }
        }
      }
      inbound {
        transferIncluded
        stayId
        durationInMin
        travelers {
          id
          name
          firstName
        }
        cancellationPolicyType
        travelSections{
          transport {
            baggage {
              quantity
              weight
              unit
            }
            class
            companyExploiter {
              id
              label
              logo
            }
            companyOperator {
              id
              label
              logo
              url
            }
            travelNumber
            type
            vehicleType
            carbonEmission
            averageCarbonEmission
          }
          departure{
            airportLabel
            cityId
            date
            id
            label
            terminalCode
            time
          }
          arrival {
            airportLabel
            cityId
            date
            id
            label
            terminalCode
            time
          }
        }
      }
    }
  }
}`;
